import type { CameraTrap } from ".";

export const cameraTrapColumns: Array<{
  id: keyof CameraTrap | "location";
  label: string;
}> = [
  { id: "number", label: "Número" },
  { id: "responsibleTeam", label: "Equipe Responsável" },
  { id: "location", label: "Localização" },
  { id: "attachmentsCount", label: "Anexos" },
] as const;
